import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { blockUiFun, getBotListData, updateCurrentTabStatus, updateFirstParam, getSelectedBotData, getBotInfo } from "../../Redux/Actions/uiActions";

import { SelectionContainer } from 'react-ui-lib';
import history from '../../Routers/history';

const SelectionView = (props) => {
    const { availableBotList, getBotListData, blockUiFun, updateCurrentTabStatus, getSelectedBotData, isCustomBot, highlightSearchedData, updateFirstParam, getBotInfo } = props;

    const [loaderState, setLoaderState] = useState(false);
    const [botListData, setBotListData] = useState([]);

    function apiCall() {
        setLoaderState(true)
        getBotListData((response)=>{
            setLoaderState(false);
        })
    }
    
    useEffect(() => {
        setBotListData(availableBotList);
    }, [availableBotList]);
    
    useEffect(()=>{
        apiCall();
        if(document.getElementById('botConfigTabs'))
            document.getElementById('botConfigTabs').style.overflowY = 'hidden';
        
        return () => {
            if(document.getElementById('botConfigTabs')) 
                document.getElementById('botConfigTabs').style.overflowY = 'auto';
        }
    }, []);

    const botSelectHandler = (data) => {
        const currentBotId = data?.id;
        
        if (!currentBotId || currentBotId === null || currentBotId === 'null') return;
        blockUiFun(true);
        updateCurrentTabStatus('chatbot');
        localStorage.setItem('sourceName', 'webpage');
        localStorage.setItem('bot_id', currentBotId);
        getBotInfo(currentBotId);
        getSelectedBotData(currentBotId, () => {
            setTimeout(() => { blockUiFun(false); }, 3000)
        }, () => {
            blockUiFun(false);
        });
        if (isCustomBot) {
            if (Object.keys(highlightSearchedData).length !== 0) {
                highlightSearchedResult({});
            }
            updateFirstParam(currentBotId + '');
            history.push(`/${currentBotId}/chatbot`);
        } else {
            updateFirstParam(currentBotId + '');
            history.push(`/${currentBotId}`);
        }
    }

    return (
        <SelectionContainer
            viewType={'bots'}
            changeTab={() => {}}
            tabsData={[
                {
                    name: "Bot(s)",
                    viewType: "bots",
                    subHeader: "bot(s)",
                    onClick: () => {},
                    img: "",
                    route:'/bot-list'
                }
            ]}
            listData={botListData}
            listLength={botListData.length}
            createBtnClick={(e) => {}}
            selectedItem={(e, data) => {
                // onItemSelection(e, data);
                botSelectHandler(data);
            }}
            showOnlyBotID={true}
            loaderState={loaderState}
            hideSubHeader={false}
            containerBody={null}
            hideCreateBtn={true}
        />
    )
}

const mapStateToProps = state => {
    return {
        availableBotList: state.UiReducer && state.UiReducer.availableBotList ? state.UiReducer.availableBotList : [],
        isCustomBot: state.UiReducer && state.UiReducer.isCustomBot ? state.UiReducer.isCustomBot : false,
        highlightSearchedData: state.UiReducer && state.UiReducer.highlightSearchedData ? state.UiReducer.highlightSearchedData : {},
    };
};

const mapDispatchToProps = dispatch => {
    const allAction = {
        getBotListData,
        blockUiFun,
        updateCurrentTabStatus,
        getSelectedBotData,
        updateFirstParam,
        getBotInfo
    }

    return bindActionCreators(allAction, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(SelectionView);